import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFormStore from "../state/useFormStore";
import ResumenPrestamo from "./ResumenPrestamo";

const ValidacionExitosa: React.FC = () => {
  const [showResumen, setShowResumen] = useState(false);

  if (showResumen) {
    return <ResumenPrestamo />;
  }

  return (
    <div className="flex flex-col items-center pt-10">
      <h1 className="text-3xl font-bold text-center pt-10">Validación Exitosa</h1>
      <p className="text-base text-center pt-5">
        ¡Tu identidad ha sido validada correctamente!
      </p>
      <button
        onClick={() => setShowResumen(true)}
        className="px-3 py-3 rounded-lg"
        style={{
          backgroundColor: "#fff200",
          color: "black",
          fontWeight: 500,
          paddingRight: 50,
          paddingLeft: 50,
          padding: "1rem",
          borderRadius: 50,
          margin: 20,
        }}
      >
        Continuar
      </button>
    </div>
  );
};

export default ValidacionExitosa;